import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76f1e391"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "footer__top" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footer__top__left" }, [
  /*#__PURE__*/_createElementVNode("h1", { "aria-label": "Say Hello" }, "TALK TO ME :)"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "mailto:adisamicheal20@gmail.com",
      target: "_blank",
      rel: "noopener"
    }, "adisamicheal20@gmail.com")
  ])
], -1))
const _hoisted_5 = { class: "footer__top__right" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Portfolio")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Blog")
const _hoisted_8 = { class: "footer__bottom" }
const _hoisted_9 = { class: "footer__bottom__left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"14px","color":"#fff","margin-top":"20px"} }, " Design and layout inspired by olaolu(dot)dev ", -1))
const _hoisted_11 = { class: "footer__bottom__right" }
const _hoisted_12 = {
  href: "https://www.linkedin.com/in/micheal-adisa-5b5250170",
  target: "_blank",
  ref: "noopener noreferrer"
}
const _hoisted_13 = {
  href: "https://github.com/adisamicheal",
  target: "_blank",
  ref: "noopener noreferrer"
}
const _hoisted_14 = {
  href: "https://michellead.hashnode.dev/",
  target: "_blank",
  ref: "noopener noreferrer"
}
const _hoisted_15 = {
  href: "https://twitter.com/michellead",
  target: "_blank",
  ref: "noopener noreferrer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/portfolio" }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, { to: "/blog" }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", null, "Micheal Adisa " + _toDisplayString(new Date().getFullYear()), 1),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_12, " LN ", 512)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_13, " GH ", 512)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_14, " HN ", 512)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", _hoisted_15, " TW ", 512)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}